import React, { useState } from 'react';
import './changePassword.css';
import { changePassword } from '../../services/admin/api'; // smart function
import { toast } from 'react-toastify';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { useNavigate } from "react-router-dom";


const ChangePassword = ({ onClose }) => {
  const [form, setForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [strength, setStrength] = useState('');
  const [show, setShow] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false
  });

   const navigate = useNavigate();
  // ---------------- PASSWORD STRENGTH ----------------
  const checkStrength = (pwd) => {
    let score = 0;
    if (pwd.length >= 8) score++;
    if (/[A-Z]/.test(pwd)) score++;
    if (/[a-z]/.test(pwd)) score++;
    if (/[0-9]/.test(pwd)) score++;
    if (/[^A-Za-z0-9]/.test(pwd)) score++;

    if (score <= 2) return 'weak';
    if (score <= 4) return 'medium';
    return 'strong';
  };

  const validateRules = (pwd) => {
    const missing = [];
    if (!/[A-Z]/.test(pwd)) missing.push("uppercase");
    if (!/[a-z]/.test(pwd)) missing.push("lowercase");
    if (!/[0-9]/.test(pwd)) missing.push("number");
    if (!/[^A-Za-z0-9]/.test(pwd)) missing.push("special character");
    if (pwd.length < 8) missing.push("8 characters");
    return missing;
  };

  // ---------------- INPUT CHANGE ----------------
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({ ...form, [name]: value });
    setError('');
    setFieldErrors({});

    if (name === 'newPassword') {
      setStrength(checkStrength(value));
    }
  };

  // ---------------- SUBMIT ----------------
  const handleSubmit = async () => {
    setError('');
    setFieldErrors({});

    // Mandatory validation
    const errors = {};
    if (!form.currentPassword) errors.currentPassword = "Current password is required";
    if (!form.newPassword) errors.newPassword = "New password is required";
    if (!form.confirmPassword) errors.confirmPassword = "Confirm password is required";

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    if (form.newPassword !== form.confirmPassword) {
      setFieldErrors({ confirmPassword: "Passwords do not match" });
      return;
    }

    const ruleErrors = validateRules(form.newPassword);
    if (ruleErrors.length > 0) {
      setFieldErrors({
        newPassword: `Must include: ${ruleErrors.join(', ')}`
      });
      return;
    }

    try {
      setLoading(true);

      const response = await changePassword(
        form.currentPassword,
        form.newPassword
      );

      if (response.status === true) {
        toast.success(response.message || "Password updated successfully");
        setTimeout(() => {onClose?.();     
        navigate("/");     
        }, 1500);
      } else {
        setError(response.message || "Failed to update password");
      }

    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="change-password-container" onClick={onClose}>
      <div className="change-password-card" onClick={(e) => e.stopPropagation()}>

        <div className="change-password-header">
          <h2>Change Password</h2>
        </div>

        {["currentPassword", "newPassword", "confirmPassword"].map((field) => (
          <div key={field} className="change-password-group">

            <label>
              {field === "currentPassword"
                ? "Current Password"
                : field === "newPassword"
                ? "New Password"
                : "Confirm Password"}
            </label>

            <div className="password-wrapper">
              <input
                type={show[field] ? "text" : "password"}
                name={field}
                value={form[field]}
                onChange={handleChange}
              />

              <span
                className="eye"
                onClick={() => setShow({ ...show, [field]: !show[field] })}
              >
                {show[field] ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>

            {/* Strength indicator only for new password */}
            {field === "newPassword" && form.newPassword && (
              <>
                <div className={`strength-bar ${strength}`} />
                <small className="password-hint">
                  Must contain uppercase, lowercase, number, special character, min 8 chars
                </small>
              </>
            )}

            {fieldErrors[field] && (
              <small className="change-password-error">
                {fieldErrors[field]}
              </small>
            )}
          </div>
        ))}

        {error && <div className="change-password-form-error">{error}</div>}

        <div className="change-password-actions">
          <button
            className="change-password-update"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update"}
          </button>

          <button
            className="change-password-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
